import React from 'react'
import classNames from 'classnames'
import LivePriceCommon from '../../LivePrices/LivePriceCommon'
import Link from '@/components/Common/Link'
import Text from '@/stories/components/Common/NewText'

type TProps = {
  indexData: {
    name?: string
    live_price?: number
    oneD_change?: number
    relative_path?: string
    socket_path?: string
    absolute_change?: number
  }
}

const IndicesCard = ({ indexData }: TProps) => {
  const {
    name = '',
    live_price = 0,
    oneD_change = 0,
    relative_path = '',
    socket_path = '',
    absolute_change = 0,
  } = indexData

  return (
    <div
      className={classNames(
        'md:w-4/10 flex h-[100px] min-w-fit cursor-pointer flex-col justify-between rounded-xl p-2 lg:h-[140px] lg:px-4 lg:py-5',
        {
          'bg-brand-tertiary-green':
            typeof oneD_change === 'number' && oneD_change >= 0,
          'bg-brand-tertiary-red':
            typeof oneD_change === 'number' && oneD_change < 0,
        },
      )}
      title={name}
      onClick={() => {
        if (relative_path) {
          window.location.href = relative_path
        }
      }}
    >
      <Link href={relative_path} title={name}>
        <Text addClassName="text-brand-black pb-1 lg:w-full text-sm lg:text-base font-medium">
          {name}
        </Text>
      </Link>

      <LivePriceCommon
        percent_change={oneD_change}
        price={live_price}
        socket_path={socket_path}
        layout="vertical"
        priceClassNames="font-medium text-base lg:text-lg"
        percentClassNames="font-normal text-[13px]"
        absolute_change={absolute_change}
      />
    </div>
  )
}

export default IndicesCard
